import React = require("react");
import "./CheckListFilter.scss";
import {defaultTheme} from "@vebox/etui-themes";
import {ThemeProvider} from "@vebox/etui-system";
import {veboxDefaultTheme} from "../index";

interface CheckListFilterProps {
    elementsUrl: string;
    selectedElementGuids: string[];
    onChange: (selectedElements: string[]) => any;
}

interface CheckListFilterState {
    configuration: CheckListFilterConfiguration;
    elements: ListElement[];
    selectedElements: string[];
    showList: boolean;
}

interface ListElement {
    guid: string;
    name: string;
}

interface CheckListFilterData {
    configuration: CheckListFilterConfiguration;
    elements: ListElement[];
}

interface CheckListFilterConfiguration {
    filterLabel: string;
}

export class CheckListFilter extends React.Component<CheckListFilterProps, CheckListFilterState> {

    private static sortElements(nodes: ListElement[]): ListElement[] {
        if (nodes == null || nodes.length === 0) {
            return nodes;
        }
        nodes.sort((n1, n2) => n1.name.localeCompare(n2.name));
        return nodes;
    }

    constructor(props: CheckListFilterProps) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.toggleList = this.toggleList.bind(this);
        this.onElementChange = this.onElementChange.bind(this);
        this.state = {
            configuration: null,
            elements: [],
            selectedElements: this.props.selectedElementGuids != null ? this.props.selectedElementGuids : [],
            showList: false,
        };
        this.loadNodes();
    }

    public componentDidMount(): void {
        if (this.props.selectedElementGuids != null && this.props.selectedElementGuids.length > 0) {
            this.props.onChange(this.props.selectedElementGuids);
        }
    }

    public render() {
        if (this.state.elements.length === 0) {
            return null;
        }
        let title = (
            <p className="check-list-filter__title" onClick={this.toggleList}>
                {this.state.configuration.filterLabel}
            </p>
        );
        if (this.state.selectedElements && this.state.selectedElements.length > 0) {
            title = (
                <p className="check-list-filter__title filtersGroupTitleEnlight" onClick={this.toggleList}>
                    {this.state.configuration.filterLabel}
                </p>
            );
        }
        const content = this.state.showList ? this.renderList() : this.renderOpenListButton();
        return (
            <ThemeProvider theme={veboxDefaultTheme}>
                <div className="check-list-filter">
                    {title}
                    {content}
                </div>
            </ThemeProvider>
        );
    }

    private loadNodes(): void {
        Ajax.ajaxRequestForJson(
            {
                url: this.props.elementsUrl,
                type: "GET",
                success: (response: CheckListFilterData) => {
                    this.setState({
                            configuration: response.configuration,
                            elements: CheckListFilter.sortElements(response.elements),
                        },
                    );
                },
            },
        );
    }

    private onChange(selectedElements: string[]): void {
        if (this.props.onChange) {
            this.props.onChange(selectedElements);
        }
        this.setState({selectedElements});
    }

    private toggleList() {
        this.setState({showList: !this.state.showList});
    }

    private isElementSelected(elementGuid: string): boolean {
        if (this.state.selectedElements == null || this.state.selectedElements.length === 0) {
            return false;
        }
        return this.state.selectedElements.indexOf(elementGuid) >= 0;
    }

    private onElementChange(event: React.ChangeEvent) {
        const guid: string = event.target.getAttribute("data-value");
        const selectedElements = this.state.selectedElements;
        if (this.isElementSelected(guid)) {
            selectedElements.splice(selectedElements.indexOf(guid), 1);
        } else {
            selectedElements.push(guid);
        }
        this.props.onChange(selectedElements);
        this.setState({selectedElements});
    }

    private renderList() {
        return (
            <ul className="check-list-filter__list">
                {this.state.elements.map((element, index) => {
                    return (
                        <li className="list-element" key={element.guid}>
                            <input
                                className="checkbox"
                                type="checkbox"
                                data-value={element.guid}
                                defaultChecked={this.isElementSelected(element.guid)}
                                onChange={this.onElementChange}
                            />
                            <p className="checkbox-label">{element.name}</p>
                        </li>
                    );
                })}
            </ul>
        );
    }

    private renderOpenListButton() {
        return (
            <div className="filterContent openChecklistFilterButton" onClick={this.toggleList}>
                <p>...</p>
            </div>
        );
    }
}
